import { MyStationsActions } from '../constants/MyStations';

export function setMyStationsDisplayType(newDisplayType) {
  return {
    type: MyStationsActions.SET_MY_STATIONS_DISPLAY,
    data: {
      newDisplayType,
    },
  };
}

export function setMyStationsDisplaySettings(newDisplayType, sortType, isDesc = false) {
  return {
    type: MyStationsActions.SET_MY_STATIONS_DISPLAY_SETTINGS,
    data: {
      newDisplayType,
      sortType,
      isDesc,
    },
  };
}

export function setMyStationsListSort(sortType, isDesc) {
  return {
    type: MyStationsActions.SET_MY_STATIONS_LIST_SORT,
    data: {
      sortType,
      isDesc,
    },
  };
}

export function updateMyStationsListVisibleFields(fieldToUpdate, newValue) {
  return {
    type: MyStationsActions.UPDATE_MY_STATIONS_LIST_VISIBLE_FIELDS,
    data: {
      fieldToUpdate,
      newValue,
    },
  };
}
